import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch, useSelector } from 'react-redux';
import { userLogin } from "../../actions/userActions";
import { useNavigate } from 'react-router-dom';
import { getLoginToken } from "../../utils/utility";

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const navigate = useNavigate();
  const { userInfo = {} } = userState;

  useEffect(() => {
    const token = getLoginToken();
    if (token) {
      const urlParams = new URLSearchParams(window.location.search);
      const r = urlParams.get('r'); // Get the value of 'r'
      if (r !== null)
        // navigate(r);
        window.location.href = r;
      else
        // navigate('/');
        window.location.href = '/';
    }
  }, [navigate, userInfo]);

  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(userLogin({ email, password }));
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow-lg" style={{ width: "400px" }}>
        <div className="card-body">
          <h3 className="card-title text-center mb-4">Stock Helper</h3>
          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter your email"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                placeholder="Enter your password"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="mb-3 form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="rememberMe"
              />
              <label className="form-check-label" htmlFor="rememberMe">
                Remember Me
              </label>
            </div>
            <button
              type="submit"
              className="btn btn-primary w-100"
              style={{ borderRadius: "25px" }}
            >
              Login
            </button>
          </form>
          <hr />
          <div className="text-center">
            <small>
              Don't have an account?{" "}
              <a href="/register" className="text-decoration-none">
                Sign Up
              </a>
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
